<template>
  <div>
    <!--  <OrganizationForm /> -->
    <br />

    <div class="d-flex">
      <div style="max-width: 24rem; width: 100%;">
        <h2 class="title">{{ $t("organization.information") }}</h2>
        <b-card-body class="text-center">
          <ImageCropper id="imageCropper" :src="form.logo" @cropperImage="cropperImage" />
          <div
            class="
                      col-md-3
                      d-flex
                      flex-column
                      justify-content-center
                      align-items-center
                    "
          >
            <a href="javascript: void(0);" @click="openCropper">
              <img
                class="
                          avatar-title
                          rounded-circle
                          bg-light
                          text-danger
                          font-size-16
                        "
                :src="form.logo"
                alt
              />
            </a>
            <a class="m-1 text-info" href="javascript: void(0);" @click="openCropper"><i class="bx bx-edit-alt text-info"></i> {{ $t("common.update") }}</a>
          </div>
        </b-card-body>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="name"
          layout="vertical"
          :label="$t('organization.name')"
          labelClass=""
          class="mb-2"
        />

        <h6 class="mt-2">{{ $t("country.name") }}</h6>
        <filter-select
          id="countriesFilter"
          ref="countriesFilter"
          :placeholder="$t('country.select')"
          :multiple="false"
          @filter="onCountriesSearch"
          :selected="form.country"
          @changed="onCountriesSelect"
          track="code"
        />
        <button :disabled="$v.$invalid" class="btn btn-main button ml-auto" @click="save" style="width: 9.375rem; height: 2.8125rem; margin-top: 2rem;">
          {{ $t("common.save") }}
        </button>
      </div>

      <div class="line"></div>
      <div style="width: 100%;">
        <h2 class="title mb-5">{{ $t("organization.company-details") }}</h2>

        <div class="alert alert-danger" v-if="$v.form.$invalid">
          <span v-if="!$v.form.nid.minLength"> {{ $t("organization.validation.nid-min-length", { length: $v.form.nid.$params.minLength.min }) }} </span>
          <span v-if="!$v.form.nid.maxLength">{{ $t("organization.validation.nid-max-length", { length: $v.form.nid.$params.maxLength.max }) }} </span>
          <span v-if="!$v.form.phone.minLength"> {{ $t("organization.validation.phone-min-length", { length: $v.form.phone.$params.minLength.min }) }} </span>
          <span v-if="!$v.form.phone.maxLength">{{ $t("organization.validation.phone-max-length", { length: $v.form.phone.$params.maxLength.max }) }} </span>
          <span v-if="$v.form.phone.$invalid">{{ $t("organization.validation.phone-is-phone") }} " (02161111111, +902161111111, 2161111111, 555-555-5555) </span>
          <span v-if="$v.form.contactPhone.$invalid">{{ $t("organization.validation.contact-is-phone") }} (02161111111, +902161111111, 2161111111, 555-555-5555) </span>
          <span v-if="$v.form.dataProtectionPhone.$invalid"
            >{{ $t("organization.validation.data-protection-is-phone") }} (02161111111, +902161111111, 2161111111, 555-555-5555 )
          </span>
          <span v-if="$v.form.email.$invalid">{{ $t("organization.validation.email") }} </span>
        </div>

        <div class="d-flex" style="gap: 1.5rem;">
          <div style="max-width: 24rem; width: 100%;">
            <sweet-input
              :isValid="!$v.form.nid.$error"
              @input="$v.form.nid.$touch()"
              v-model="form.nid"
              type="text"
              layout="vertical"
              :label="$t('organization.organization-nid')"
              labelClass=""
              class="mb-3"
            />
            <sweet-input
              :isValid="!$v.form.title.$error"
              @input="$v.form.title.$touch()"
              v-model="form.title"
              type="text"
              layout="vertical"
              :label="$t('organization.organization-title')"
              labelClass=""
              class="mb-3"
            />
            <sweet-input
              :isValid="!$v.form.taxOffice.$error"
              @input="$v.form.taxOffice.$touch()"
              v-model="form.taxOffice"
              type="text"
              layout="vertical"
              :label="$t('organization.tax-office')"
              labelClass=""
              class="mb-3"
            />
            <sweet-input
              :isValid="!$v.form.kep.$error"
              @input="$v.form.kep.$touch()"
              v-model="form.kep"
              type="text"
              layout="vertical"
              :label="$t('organization.kep')"
              labelClass=""
              class="mb-3"
            />
          </div>
          <div style="max-width: 24rem; width: 100%;">
            <sweet-input
              :isValid="!$v.form.web.$error"
              @input="$v.form.web.$touch()"
              v-model="form.web"
              type="text"
              layout="vertical"
              :label="$t('organization.web')"
              labelClass=""
              class="mb-3"
            />
            <sweet-input
              :isValid="!$v.form.email.$error"
              @input="$v.form.email.$touch()"
              v-model="form.email"
              type="email"
              layout="vertical"
              :label="$t('organization.email')"
              labelClass=""
              class="mb-3"
            />
            <sweet-input
              :isValid="!$v.form.phone.$error"
              @input="$v.form.phone.$touch()"
              v-model="form.phone"
              type="text"
              layout="vertical"
              :label="$t('organization.phone')"
              labelClass=""
              class="mb-3"
              placeholder="+90 xxx xxx xx xx"
            />

            <sweet-input
              :isValid="!$v.form.address.$error"
              @input="$v.form.address.$touch()"
              v-model="form.address"
              type="text"
              layout="vertical"
              :label="$t('organization.address')"
              labelClass=""
              class="mb-3"
            />
          </div>
        </div>

        <!-- <h2 class="title mb-5">{{ $t("organization.contact-information") }}</h2>
        <div class="d-flex" style="gap: 1.5rem;">
          <div style="max-width: 24rem; width: 100%;">
            <sweet-input
              :isValid="!$v.form.contactName.$error"
              @input="$v.form.contactName.$touch()"
              v-model="form.contactName"
              type="text"
              layout="vertical"
              :label="$t('organization.contact-name')"
              labelClass=""
              class="mb-3"
            />
            <sweet-input
              :isValid="!$v.form.contactEmail.$error"
              @input="$v.form.contactEmail.$touch()"
              v-model="form.contactEmail"
              type="email"
              layout="vertical"
              :label="$t('organization.contact-email')"
              labelClass=""
              class="mb-3"
            />
          </div>
          <div style="max-width: 24rem; width: 100%;">
            <sweet-input
              :isValid="!$v.form.contactPhone.$error"
              @input="$v.form.contactPhone.$touch()"
              v-model="form.contactPhone"
              type="text"
              layout="vertical"
              :label="$t('organization.contact-phone')"
              labelClass=""
              placeholder="+90 xxx xxx xx xx"
              class="mb-3"
            />
            <sweet-input
              :isValid="!$v.form.contactAddress.$error"
              @input="$v.form.contactAddress.$touch()"
              v-model="form.contactAddress"
              type="text"
              layout="vertical"
              :label="$t('organization.contact-adress')"
              labelClass=""
              class="mb-3"
            />
          </div>
        </div>
        <br />
        <h2 class="title mb-5">{{ $t("organization.data-protection-information") }}</h2>
        <div class="d-flex" style="gap: 1.5rem;">
          <div style="max-width: 24rem; width: 100%;">
            <sweet-input
              :isValid="!$v.form.dataProtectionName.$error"
              @input="$v.form.dataProtectionName.$touch()"
              v-model="form.dataProtectionName"
              type="text"
              layout="vertical"
              :label="$t('organization.data-protection-name')"
              labelClass=""
              class="mb-3"
            />
            <sweet-input
              :isValid="!$v.form.dataProtectionEmail.$error"
              @input="$v.form.dataProtectionEmail.$touch()"
              v-model="form.dataProtectionEmail"
              type="email"
              layout="vertical"
              :label="$t('organization.data-protection-email')"
              labelClass=""
              class="mb-3"
            />
          </div>
          <div style="max-width: 24rem; width: 100%;">
            <sweet-input
              :isValid="!$v.form.dataProtectionPhone.$error"
              @input="$v.form.dataProtectionPhone.$touch()"
              v-model="form.dataProtectionPhone"
              type="text"
              layout="vertical"
              :label="$t('organization.data-protection-phone')"
              labelClass=""
              class="mb-3"
              placeholder="+90 xxx xxx xx xx"
            />
            <sweet-input
              :isValid="!$v.form.dataProtectionAdress.$error"
              @input="$v.form.dataProtectionAdress.$touch()"
              v-model="form.dataProtectionAdress"
              type="text"
              layout="vertical"
              :label="$t('organization.data-protection-adress')"
              labelClass=""
              class="mb-3"
            />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import ImageCropper from "@c/form/image-cropper";
import { email, helpers, maxLength, minLength, required } from "vuelidate/lib/validators";
import Countries from "../countries/countries.json";
import { image as defaultImage } from "./default-organization-image";
import OrganizationForm from "./organization-form.vue";
const phone = helpers.regex("serial", /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i);

const url = helpers.regex(
  "serial",
  /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})??/
);

const state = "organization";

const schema = {
  logo: defaultImage,
  nid: undefined,
  title: undefined,
  taxOffice: undefined,
  phone: undefined,
  address: undefined,
  web: undefined,
  email: undefined,
  kep: undefined,
  contactName: undefined,
  contactEmail: undefined,
  contactPhone: undefined,
  contactAddress: undefined,
  dataProtectionName: undefined,
  dataProtectionEmail: undefined,
  dataProtectionPhone: undefined,
  dataProtectionAdress: undefined,
};
export default {
  components: { OrganizationForm, ImageCropper },
  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
      form: { ...schema, name: undefined, country: undefined, relationship: undefined },
      workspace: undefined,
      submitted: false,
    };
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedOrganization() {
      return this.$store.getters[`${state}/editedOrganization`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
    workspaces() {
      return this.$store.getters["workspace/pagination"];
    },

    pagination() {
      return this.$store.getters["organization/pagination"];
    },
    isFormValid() {
      if (!this.isEditMode && !this.workspace) {
        return false;
      }
      return !this.$v.$invalid;
    },
  },

  watch: {
    editedOrganization: {
      handler(v) {
        if (v) {
          this.form = { ...v };
        }
        if (!this.form.logo) {
          this.form.logo = defaultImage;
        }
      },
      deep: true,
      immediate: true,
    },

    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },

    $route: {
      handler: function() {
        if (this.currentOrganization) {
          this.$store.commit("organization/editedOrganization", { ...this.currentOrganization });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  validations: {
    form: {
      name: { required, minLength: minLength(1), maxLength: maxLength(40) },
      country: { required },
      nid: { minLength: minLength(10), maxLength: maxLength(11) },
      title: {},
      taxOffice: {},
      kep: {},
      web: {
        url,
      },
      email: {
        email,
      },
      phone: {
        phone,
        minLength: minLength(10),
        maxLength: maxLength(17),
      },
      address: {},

      contactName: {},
      contactEmail: { email },
      contactPhone: { phone, minLength: minLength(6), maxLength: maxLength(17) },
      contactAddress: {},

      dataProtectionName: {},
      dataProtectionEmail: { email },
      dataProtectionPhone: { phone, minLength: minLength(6), maxLength: maxLength(17) },
      dataProtectionAdress: {},
    },
  },

  async mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch(`${state}/save`, {
          organization: this.form,
          workspace: this.workspace,
        });

        this.$toast.success(this.$t("common.success"));
        this.resetForm();

        setTimeout(() => {
          window.location.href = "/organization";
        }, 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    setWorkspace(workspace) {
      this.workspace = workspace;
    },
    openCropper() {
      this.$bvModal.show("imageCropper");
    },
    cropperImage(value) {
      this.form.logo = value;
      this.$bvModal.hide("imageCropper");
      this.$forceUpdate();
    },
    resetForm() {
      this.form = { ...schema };
    },
    async onCountriesSearch(value, callback) {
      const lang = "tr";
      const response = Countries.filter((x) => x.name[lang].toLowerCase().includes(value.toLowerCase()));
      callback(response);
    },
    onCountriesSelect(item) {
      this.form = { ...this.form, country: item };
    },

    paginate() {
      this.$store.dispatch(`workspace/paginate`, { pagination: this.request });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  margin-bottom: 1rem;
}

.org-logo {
  width: 3.90625rem;
  height: 3.90625rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #d9d9d9;
  margin-bottom: 0.5rem;
}

.org-logo--update {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #344054;
  font-family: "Inter";
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
  margin-bottom: 1.5rem;
}

.line {
  display: block;
  width: 1px;
  height: 382px;
  border-right: 1px solid #d0d5dd;
  margin: 0 3.25rem;
}

input {
  width: 22rem !important;
}
</style>
